export const SET_ACTIVE_TAB = 'SET_ACTIVE_TAB';
export const RESET_FILTERS = 'RESET_FILTERS';

export function setActiveTab (tab) {
  return dispatch => {
    dispatch({ type: SET_ACTIVE_TAB, payload: tab })
  }
}

export function resetFilters() {
  return dispatch => {
    dispatch({ type: RESET_FILTERS })
  }
}


// WEBPACK FOOTER //
// ./src/redux/actions/agentsPaymentReducer.js